<!-- AbsoluteURL (custom mark) -->
<script lang="ts">
	import type { MarkComponentProps } from '@portabletext/svelte';

	interface Props {
		portableText: MarkComponentProps<{ href: string; documentType: string }>;
		children?: import('svelte').Snippet;
	}

	let { portableText, children }: Props = $props();
</script>

<!-- eslint-disable svelte/no-navigation-without-resolve -->
<a href={portableText.value.href} data-sveltekit-preload-data>
	{@render children?.()}
</a>
